/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShapeCircleMOffIcon16Light = forwardRef('ShapeCircleMOffIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.354 1.646a.5.5 0 1 0-.708.708l1.772 1.772a6 6 0 0 0 8.456 8.456l1.772 1.772a.5.5 0 0 0 .708-.708l-12-12Zm8.81 10.226L4.13 4.835a5 5 0 0 0 7.036 7.036Z" }),
        React.createElement("path", { d: "M13 8c0 .68-.136 1.33-.382 1.92l.754.755a6 6 0 0 0-8.047-8.047l.754.754A5 5 0 0 1 13 8Z" })));
});
